module.exports = __webpack_public_path__ + "img/1.5481c609.jpeg";